// removed by extract-text-webpack-plugin
module.exports = {"action-bar":"app-pages-Ingredient-Category-ActionBar-__ActionBar___38SQ_"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Ingredient/Category/ActionBar/ActionBar.css
// module id = 2347
// module chunks = 0